import React from 'react';
import PaidSearchDoubleOptionBarChart from '../PaidSearchDoubleOptionBarChart';
import PaidSearchKeyMetricCards from '../PaidSearchKeyMetricCards';
import AdvertisingMultiMetricTrendChart from '../AdvertisingMultiMetricTrendChart';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import {
  BEACON_CHART_SPACING,
  BEACON_PRO_PAGE_MARGIN_BOTTOM
} from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { PercentTotalTrafficSplineChart } from '../../Total/PercentTotalTrafficSplineChart';
import { PaidSearchTopicsGrid } from '../Topics/PaidSearchTopicsGrid';
import { TrafficByTopicBarChart } from '../../TrafficByTopicBarChart';
import { TrafficAdvancedSearchBarChart } from '../../TrafficAdvancedSearchBarChart';
import { useMainEntityType, useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import { TrafficNoDataPlaceholder } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Total/pages/NonTopicOrTopicGroupPage';
import { useTrafficAvailability } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/Total/hooks/useTrafficAvailability';
import PaidSearchGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/PaidSearch/PaidSearchGrid';
import {
  PAID_SEARCH_TREND_CHART_ID,
  PaidSearchMetricProvider
} from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/PaidSearch/PaidSearchMetricContext';
import { ExportConfigProvider } from 'src/components/BeaconV2Components/common/AppExportModal/ExportModalContext';
import { ChartContextProvider } from 'src/utils/chartContext/ChartContextGroupContext';
import { CHART_CONTEXT_GROUPS, CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

/**
 * Paid search page for non topic views
 */
export function NonTopicOrTopicGroupPage() {
  const mainEntityType = useMainEntityType();
  const { isProductEntity } = useProductEntity();
  const { dataAvailable } = useTrafficAvailability();

  return (
    <ExportConfigProvider overrideShouldIntercept={true}>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING} marginBottom={BEACON_PRO_PAGE_MARGIN_BOTTOM}>
        {dataAvailable ? (
          <>
            <PaidSearchMetricProvider>
              <PaidSearchKeyMetricCards />
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_BAR_CHART.name}
                chartName={CHART_NAMES.BEACON_PAID_SEARCH_BAR_CHART_COLUMN}
              >
                <PaidSearchDoubleOptionBarChart />
              </ChartContextProvider>
              <div id={PAID_SEARCH_TREND_CHART_ID}>
                <ChartContextProvider
                  group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_TREND_CHART.name}
                  chartName={CHART_NAMES.BEACON_PAID_SEARCH_TREND_CHART_SPLINE}
                >
                  <AdvertisingMultiMetricTrendChart />
                </ChartContextProvider>
              </div>
            </PaidSearchMetricProvider>
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_BY_TOPIC.name}
              chartName={CHART_NAMES.BEACON_PAID_SEARCH_BY_TOPIC_BAR}
            >
              <TrafficByTopicBarChart metric="paidTraffic" />
            </ChartContextProvider>
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_BY_KEYWORD.name}
              chartName={CHART_NAMES.BEACON_PAID_SEARCH_BY_KEYWORD_BAR}
            >
              <TrafficAdvancedSearchBarChart metric="adClicks" groupByField="searchTerm" />
            </ChartContextProvider>
            {!['category', 'subcategory', 'product'].includes(mainEntityType) && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_BY_CATEGORY.name}
                chartName={CHART_NAMES.BEACON_PAID_SEARCH_BY_CATEGORY_BAR}
              >
                <TrafficAdvancedSearchBarChart metric="adClicks" groupByField="categoryId" />
              </ChartContextProvider>
            )}
            {!['subcategory', 'product'].includes(mainEntityType) && (
              <ChartContextProvider
                group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_BY_SUBCATEGORY.name}
                chartName={CHART_NAMES.BEACON_PAID_SEARCH_BY_SUBCATEGORY_BAR}
              >
                <TrafficAdvancedSearchBarChart metric="adClicks" groupByField="subCategoryId" />
              </ChartContextProvider>
            )}
            <ChartContextProvider
              group={CHART_CONTEXT_GROUPS.BEACON_PAID_SEARCH_PERCENT_TRAFFIC.name}
              chartName={CHART_NAMES.BEACON_PAID_SEARCH_PERCENT_TRAFFIC_SPLINE}
            >
              <PercentTotalTrafficSplineChart trafficType="paidTraffic" />
            </ChartContextProvider>
            {isProductEntity ? <PaidSearchGrid /> : <PaidSearchTopicsGrid />}
          </>
        ) : (
          <TrafficNoDataPlaceholder />
        )}
      </Flex>
    </ExportConfigProvider>
  );
}
